import { Button } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { ExportReportAccountsModel } from '../../model';

export const createExportReportAccountsButton = (model: ExportReportAccountsModel) => {
	const ExportReportAccountButton = () => {
		const { t } = useTranslation();
		const exportButtonClicked = useUnit(model.exportButtonClicked);

		return (
			<Button onClick={exportButtonClicked}>{t('export-report-accounts.export-excel')}</Button>
		);
	};

	return ExportReportAccountButton;
};
